<template>
	<div>
		<base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
			<AdminMenu></AdminMenu>
		</base-header>
		<div class="container-fluid mt--7">
			<div class="row">
				Admin
			</div>
		</div>
	</div>
</template>
<script>
import AdminMenu from '@/components/AdminMenu'
export default {
	data() {
		return {
			apiKey: false
		};
	},
	components: {
		AdminMenu
	},
	computed: {
		user () {
			return this.$store.getters["auth/user"];
		}
	}
};
</script>
<style></style>
